/*
 * Cautiva mobile filter trigger — sticky bottom-right floating button
 * that opens the stock Horizon #filters-drawer dialog. Mobile-only via
 * CSS @media gate. The custom element hides itself when the inline
 * filter button (Horizon's <button class="facets-toggle__button">) is
 * intersecting the viewport, so the two controls don't compete.
 *
 * Pairs with sections/cautiva-collection-main.liquid + the stock
 * blocks/filters.liquid drawer. Click delegates to Horizon's existing
 * event-binding `on:click="#filters-drawer/showDialog"`, so no manual
 * dialog API call here.
 */

(() => {
  if (customElements.get('cautiva-mobile-filter-trigger')) return;

  class CautivaMobileFilterTrigger extends HTMLElement {
    #observer = null;
    #sentinel = null;

    connectedCallback() {
      const sentinelSelector = this.dataset.sentinel || '.facets-toggle__button';
      this.#sentinel = document.querySelector(sentinelSelector);

      if (!this.#sentinel || typeof IntersectionObserver === 'undefined') {
        this.setAttribute('data-visible', 'true');
        return;
      }

      this.setAttribute('data-visible', 'false');

      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            this.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
          }
        },
        { root: null, threshold: 0 }
      );

      this.#observer.observe(this.#sentinel);
    }

    disconnectedCallback() {
      if (this.#observer) {
        this.#observer.disconnect();
        this.#observer = null;
      }
      this.#sentinel = null;
    }
  }

  customElements.define('cautiva-mobile-filter-trigger', CautivaMobileFilterTrigger);
})();
